import Banner from "../components/termsConditions/Banner";
import Conditions from "../components/termsConditions/Conditions";

export default function TermsConditions() {
  return (
    <>
      <Banner />
      <Conditions />
    </>
  );
}
